import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiHook } from "../../hooks/apiHook";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Stripe from "../../views/payment/Stripe";
import { useNavigate } from "react-router";

const AnnualFeeSubscription = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userData = useSelector((state) => state.user?.loginResponse?.user);
  const [stripePublicKey, setStripePublicKey] = useState("");
  const [paymentIntentId, setPaymentIntentId] = useState("");
  const userSelectedCurrency = useSelector(
    (state) => state.user?.selectedCurrency
  );
  const data = ApiHook.CallGetAnnualFeeDetails();
  const [clientSecret, setClientSecret] = useState("");
  const paymentMethods = ApiHook.CallPaymentMethods("membership_renewal");
  const [stripeIntentStatus, setStripeIntentStatus] = useState("");
  const stripeIntent = ApiHook.CallCreateStripePaymentIntent();
  const updateStripeIntent =
    ApiHook.CallUpdateStripePaymentIntent(paymentIntentId);
  const cancelStripeIntent = ApiHook.CallCancelStripePaymentIntent();
  const [subscriptionId, setSubscriptionId] = useState("");
  console.log({ data });
  console.log({ paymentMethods });
  const annualFeeSubscription = ApiHook.CallAnnualFeeSubscription();

  const handleSubmit = (paymentId, paymentIntent, paymentType) => {
    let data = {
      stripeResponse: paymentIntent,
    };
    annualFeeSubscription.mutate(data, {
      onSuccess: (res) => {
        if (res?.status) {
          toast.success(t(res?.data));
          navigate("/profile");
        } else {
          toast.error(t(res?.data?.description));
          setPaymentIntentId("");
          setClientSecret("");
          setStripeIntentStatus("");
        }
      },
    });
  };

  const handleButtonClick = () => {
    setStripePublicKey(paymentMethods.data.stripePublicKey);
    if (paymentIntentId === "") {
      const body = {
        productId: null,
        type: "annual_fee_subscription",
      };
      stripeIntent.mutateAsync(body, {
        onSuccess: (res) => {
          if (res.status) {
            console.log(res.client_secret, "res");
            setClientSecret(res.client_secret);
            setPaymentIntentId(res.id);
            setStripeIntentStatus(res.status);
            setSubscriptionId(res.subscriptionId);
          } else {
            toast.error(res.description);
          }
        },
      });
    } else {
      const body = {
        productId: data?.packageId,
        paymentIntentId: paymentIntentId,
        type: "register",
      };
      updateStripeIntent.mutateAsync(body, {
        onSuccess: (res) => {
          setStripeIntentStatus(res.status);
        },
      });
    }
  };
  return (
    <>
      <div className="page_head_top">{t("annualFeeSubscription")}</div>
      {/* {data && data.feeStatus ? (
            <div className="fee-status-container">
            <p className="status-message success">
                {t("yourFeeStatus")} {t("isPending")}!
            </p>
            <button className="pay-now-button">{t("payNow")}</button>
            </div>
        ) : (
            <div className="fee-status-container">
            <p className="status-message completed">
                {t("annualFeeAlreadyPaid")}
            </p>
            </div>
        )} */}
      <div style={styles.pageContainer}>
        <div style={styles.contentContainer}>
          {data && data.feeStatus ? (
            <div style={styles.messageContainer}>
              <p style={{ ...styles.message, color: "#007BFF" }}>
                {t("yourFeeStatus")} {t("isPending")}.
              </p>

              {stripePublicKey !== "" && clientSecret !== "" && (
                <Stripe
                  clientSecret={clientSecret}
                  handleSubmit={handleSubmit}
                  publicKey={stripePublicKey}
                />
              )}
              {stripePublicKey === "" && clientSecret === "" && (
                <button style={styles.button} onClick={handleButtonClick}>
                  {t("payNow")}
                </button>
              )}
            </div>
          ) : (
            <div style={styles.messageContainer}>
              <p style={{ ...styles.message, color: "#28A745" }}>
                {t("annualFeeAlreadyPaid")}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const styles = {
  pageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh", // Full height of the viewport
    backgroundColor: "#f4f4f4", // Subtle background color
    margin: "0",
    width: "100%",
  },
  contentContainer: {
    textAlign: "center",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    maxWidth: "400px",
    width: "100%",
  },
  header: {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  messageContainer: {
    marginTop: "20px",
  },
  message: {
    fontSize: "16px",
    marginBottom: "10px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "14px",
    color: "#fff",
    backgroundColor: "#007BFF",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default AnnualFeeSubscription;
